import SearchspringListingBase from "@theme/searchspring-base";
import { getSearchExpansionConfig } from "@theme/searchspring-variant-engine";

export default class SearchResultsList extends SearchspringListingBase {
  async initExpansionConfig() {
    const config = getSearchExpansionConfig();

    this.enableExpansion = config.enableExpansion;
    this.resultsPerPage = config.resultsPerPage;
    this.oosSortingRule = config.oosSortRule;
    this.variantSortOverride = config.variantSortOverride;
    this.saleColorName = config.saleColorName;
    this.saleColorId = config.saleColorId;
    this.displayNonSaleVariants = config.displayNonSaleVariants;
  }

  initContext() {
    const params = new URLSearchParams(window.location.search);
    const pageFromUrl = parseInt(params.get('page'));
    this.currentPage = pageFromUrl && pageFromUrl > 1 ? pageFromUrl : 1;
    this.currentSearchQuery = params.get('q') || '';

    const filterParams = new URLSearchParams();
    for (const [key, value] of params.entries()) {
      // Skip system parameters
      if (key === 'page' || key === 'sort_by' || key === 'q') {
        continue;
      }

      // Check if it's already a technical field (starts with 'filter.')
      if (key.startsWith('filter.')) {
        filterParams.append(key, value);
      } else {
        // Try to convert pretty URL slug to technical field
        const technicalField = SearchspringListingBase.urlToFilterField(key);
        if (technicalField && technicalField.startsWith('filter.')) {
          filterParams.append(technicalField, value);
        }
      }
    }

    this.activeFilters = filterParams.toString();
  }

  async connectedCallback() {
    await super.connectedCallback();
    this.tabsInit();
  }

  postRenderProductBatch(appendedCards = []) {
    if (!this.currentSearchQuery) return;

    appendedCards.forEach((card) => {
      const titleElement = card.querySelector('.product-card-item__title a');

      if (!titleElement) return;

      const originalText = titleElement.textContent;
      titleElement.innerHTML = this.highlightText(originalText, this.currentSearchQuery);
    });
  }

  tabsInit() {
    const tabs = this.querySelectorAll('.js-tab-link');
    const contents = this.querySelectorAll('.js-tab');

    if (!tabs.length || !contents.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-tab');
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        contents.forEach(c => {
          c.classList.toggle('is-active', c.id === `tab-${target}`);
        });
      });
    });
  }

  getEndpoint() {
    return 'search.json';
  }

  getBaseParams(page) {
    return {
      ...super.getBaseParams(page),
      q: this.currentSearchQuery
    };
  }
}

if (!customElements.get('search-results-list')) {
  customElements.define('search-results-list', SearchResultsList);
}
